export default __webpack_public_path__ + "static/media/setting-solid.c736f037.svg";